// src/fetchers/axios.ts
import axios from "axios";
var axiosFetcher = async (url, { method, body }) => {
  const response = await axios.request({ url, method, data: body });
  return response.data;
};
export {
  axiosFetcher
};
